
import { defineComponent, PropType } from 'vue'
import { usePreloaderModel } from '@shared/model/preloader'
import { useRestaurantModel } from '@entities/restaurant'
import { useThemeModel } from '@entities/theme'
import { useOrderModel } from '@entities/order'
import { ButtonClose } from '@shared/ui'

interface IData {
  paramsRestaurant: string
  paramsId: string
  locationHost: string
}
export default defineComponent({
  name: 'ApplyDiscountModal',

  components: {
    ButtonClose
  },

  props: {
    restId: {
      type: String as PropType<string>,
      required: true,
      default: ''
    }
  },

  emits: ['closeApplyDiscount', 'onScanner'],

  setup () {
    const themeModel = useThemeModel()
    const restaurantModel = useRestaurantModel()
    const preloaderModel = usePreloaderModel()
    const orderModel = useOrderModel()

    return {
      themeModel,
      restaurantModel,
      preloaderModel,
      orderModel
    }
  },

  data (): IData {
    return {
      paramsRestaurant: '',
      paramsId: '',
      locationHost: ''
    }
  },
  computed: {
    orderId (): string {
      if (this.orderModel.orderData?.orders.length) {
        return this.orderModel.orderData.orders[0].order_id.replace(/[{()}]/g, '')
      }
      return '0'
    }
  },
  mounted () {
    this.paramsRestaurant = this.restaurantModel.code
    this.paramsId = this.$route.params.id
    this.locationHost = window.location.host
  },
  methods: {
    openScanner (): void {
      this.$emit('onScanner')
      this.$emit('closeApplyDiscount')
    },

    discountMobileApp (): void {
      this.preloaderModel.status = true
      window.location.href = 'https://novikovgroup.page.link/?uuid=' + this.orderId + '&rest_id=' + this.restId + '&table_id=' + this.paramsId + '&return_url=https://' + this.locationHost + '/' + this.paramsRestaurant + '/' + this.paramsId
      setTimeout(() => {
        this.preloaderModel.status = false
      }, 5000)
      this.$emit('closeApplyDiscount')
    }
  }
})
